import { nullSafeToString } from '../lib/util';

/**
 * The billing address recorded on an {@link Order Order}.
 *
 * {@link Order Order} already carries a `billingAddress`, but the API flattens it onto the order without
 * the state and country names - it has only the ids. This is the same address resolved, and is what to
 * render when a receipt has to show a complete address.
 *
 * @property {string} firstName - (Read only) First name on the billing address.
 * @property {string} lastName - (Read only) Last name on the billing address.
 * @property {string} company - (Read only) Company on the billing address.
 * @property {string} address - (Read only) Street address.
 * @property {string} address2 - (Read only) Second street address line.
 * @property {string} city - (Read only) City.
 * @property {string} postalCode - (Read only) Postal code.
 * @property {?number} stateId - (Read only) The id of the state (region). Null for countries without them.
 * @property {string} stateName - (Read only) The name of the state (region). Empty for countries without them.
 * @property {?number} countryId - (Read only) The id of the country.
 * @property {string} countryName - (Read only) The name of the country.
 * @property {string} countryAbbreviation - (Read only) The two letter abbreviation for the country.
 */

class OrderBillingAddress {
    constructor (data = {}) {
        this.firstName = nullSafeToString(data.billingFname);
        this.lastName = nullSafeToString(data.billingLname);
        this.company = nullSafeToString(data.billingCompany);
        this.address = nullSafeToString(data.billingAddress);
        this.address2 = nullSafeToString(data.billingAddress2);
        this.city = nullSafeToString(data.billingCity);
        this.postalCode = nullSafeToString(data.billingZip);

        this.stateId = data.billingStateId || null;
        this.stateName = nullSafeToString(data.billingStateName);
        this.countryId = data.billingCountryId || null;
        this.countryName = nullSafeToString(data.billingCountryName);
        this.countryAbbreviation = nullSafeToString(data.billingCountryAbbreviation);

        Object.freeze(this);
    }
}

export default OrderBillingAddress;
